import { render, staticRenderFns } from "./courseMaterialsManage.vue?vue&type=template&id=2cc07bf6&scoped=true"
import script from "./courseMaterialsManage.vue?vue&type=script&lang=js"
export * from "./courseMaterialsManage.vue?vue&type=script&lang=js"
import style0 from "./courseMaterialsManage.vue?vue&type=style&index=0&id=2cc07bf6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc07bf6",
  null
  
)

export default component.exports